import { gql } from "@apollo/client";

export const RESCHEDULE_PUBLISH_CONTENT = gql`
  mutation authoring_reSchedulePublishContent(
    $contentType: authoring_ContentTypes!
    $input: authoring_ScheduleChangeInfo
  ) {
    authoring_reSchedulePublishContent(contentType: $contentType, input: $input) {
      message
      parent_page_url
      current_page_url
    }
  }
`;

export const RESCHEDULE_UNPUBLISH_CONTENT = gql`
  mutation authoring_reScheduleUnpublishContent(
    $contentType: authoring_ContentTypes!
    $input: authoring_ScheduleChangeInfo
  ) {
    authoring_reScheduleUnpublishContent(contentType: $contentType, input: $input) {
      message
      parent_page_url
      current_page_url
    }
  }
`;

export const CANCEL_SCHEDULE_PUBLISH_CONTENT = gql`
  mutation authoring_cancelSchedulePublishContent(
    $contentType: authoring_ContentTypes!
    $input: authoring_CancelScheduleInfo
  ) {
    authoring_cancelSchedulePublishContent(contentType: $contentType, input: $input) {
      message
      parent_page_url
      current_page_url
    }
  }
`;

export const CANCEL_SCHEDULE_UNPUBLISH_CONTENT = gql`
  mutation authoring_cancelScheduleUnpublishContent(
    $contentType: authoring_ContentTypes!
    $input: authoring_CancelScheduleInfo
  ) {
    authoring_cancelScheduleUnpublishContent(contentType: $contentType, input: $input) {
      message
      parent_page_url
      current_page_url
    }
  }
`;

// ---------------------------------------------------------------------------------------------
// Schema-based types (gallery, tournament, ...) — keyed by `document_name`
// ---------------------------------------------------------------------------------------------

export const RESCHEDULE_PUBLISH_SCHEMA_CONTENT = gql`
  mutation authoring_reSchedulePublishSchemaContent(
    $contentType: String
    $input: authoring_RescheduleData
    $schema_document_type: String
  ) {
    authoring_reSchedulePublishSchemaContent(
      contentType: $contentType
      input: $input
      schema_document_type: $schema_document_type
    ) {
      message
      path
    }
  }
`;

export const RESCHEDULE_UNPUBLISH_SCHEMA_CONTENT = gql`
  mutation authoring_reScheduleUnpublishSchemaContent(
    $contentType: String
    $input: authoring_RescheduleData
    $schema_document_type: String
  ) {
    authoring_reScheduleUnpublishSchemaContent(
      contentType: $contentType
      input: $input
      schema_document_type: $schema_document_type
    ) {
      message
      path
    }
  }
`;

export const CANCEL_SCHEDULE_PUBLISH_SCHEMA_CONTENT = gql`
  mutation authoring_cancelSchedulePublishSchemaContent(
    $contentType: String
    $input: authoring_CancelScheduleData
    $schema_document_type: String
  ) {
    authoring_cancelSchedulePublishSchemaContent(
      contentType: $contentType
      input: $input
      schema_document_type: $schema_document_type
    ) {
      message
      path
    }
  }
`;

export const CANCEL_SCHEDULE_UNPUBLISH_SCHEMA_CONTENT = gql`
  mutation authoring_cancelScheduleUnpublishSchemaContent(
    $contentType: String
    $input: authoring_CancelScheduleData
    $schema_document_type: String
  ) {
    authoring_cancelScheduleUnpublishSchemaContent(
      contentType: $contentType
      input: $input
      schema_document_type: $schema_document_type
    ) {
      message
      path
    }
  }
`;

export type ScheduleAction =
  | "reschedulePublish"
  | "rescheduleUnpublish"
  | "cancelPublish"
  | "cancelUnpublish";

export type ScheduleFamily = "fixed" | "schema";

/** The document for each (family, action) pair. */
export const SCHEDULE_ACTION_DOCUMENTS = {
  fixed: {
    reschedulePublish: RESCHEDULE_PUBLISH_CONTENT,
    rescheduleUnpublish: RESCHEDULE_UNPUBLISH_CONTENT,
    cancelPublish: CANCEL_SCHEDULE_PUBLISH_CONTENT,
    cancelUnpublish: CANCEL_SCHEDULE_UNPUBLISH_CONTENT,
  },
  schema: {
    reschedulePublish: RESCHEDULE_PUBLISH_SCHEMA_CONTENT,
    rescheduleUnpublish: RESCHEDULE_UNPUBLISH_SCHEMA_CONTENT,
    cancelPublish: CANCEL_SCHEDULE_PUBLISH_SCHEMA_CONTENT,
    cancelUnpublish: CANCEL_SCHEDULE_UNPUBLISH_SCHEMA_CONTENT,
  },
} as const;
